<div [formGroup]="formGroup">
  <ng-container *ngIf="arrangement.contacts$ | async as contacts">

    <ng-container *ngIf="contacts.length; else noContacts" >

      <ng-container *ngIf="!hideContactSelector">

        <div class="flex" #contactDropDownWrapper>

          <p-dropdown #contactDropDown formControlName="id" [showClear]="true" [options]="contacts" optionLabel="name" optionValue="id" filterBy="name" class="contact-selector flex-auto w-1" placeholder="Select, or create, a Contact" appendTo="body" (onClear)="onValueClear()" (onChange)="onValueChange()">
    
            <ng-template pTemplate="empty">
              <span (click)="onAddNewContact($event)" class="block w-full">Add New Contact</span>
            </ng-template>
    
            <ng-template pTemplate="footer">
              <div class="px-3 py-2 border-top-1 border-right-none border-bottom-none border-left-none border-solid border-300"><span (click)="onAddNewContact($event)" class="block w-full">Add New Contact</span></div>
            </ng-template>
    
            <ng-template let-contact pTemplate="selectedItem">
              <div class="flex justify-content-between align-items-center">
                <div class="flex align-items-center options-item options-item-value" [class.unnamed]="contact.name === 'Unnamed Contact'">{{ contact.name }}{{ contact.relationships.length ? ' - ' : '' }}{{ contact.relationships.join(', ') }}</div>
                <div *ngIf="validationErrors?.list?.length as errorCount"><p-badge [value]="'Missing Details'" severity="warning" styleClass="badge-error-count"></p-badge></div>
              </div>
            </ng-template>
    
            <ng-template let-contact pTemplate="item">
              <div class="flex align-items-center options-item" [class.unnamed]="contact.name === 'Unnamed Contact'">
                <div>{{ contact.name }}{{ contact.relationships.length ? ' - ' : '' }}{{ contact.relationships.join(', ') }}</div>
              </div>
            </ng-template>
    
          </p-dropdown>
    
          <p-button class="contact-visibility flex-none" (click)="onViewContact($event)" [disabled]="!formGroup.get('id')?.value" [icon]="isVisible ? 'pi pi-eye' : 'pi pi-eye-slash'"></p-button>

        </div>

      </ng-container>

    </ng-container>

    <ng-container *ngIf="isVisible && contacts.length">

      <p-divider></p-divider>

      <p-card *ngIf="activeContact as contact; else noContact" styleClass="shadow-3 app-surface-tint border-round-md relative" class="w-full">
        
        <i *ngIf="saving" class="pi pi-spin pi-spinner"></i>

        <div class="flex align-items-center justify-content-between text-left flex-wrap gap-3">
          <p-avatar *ngIf="contact.name" class="flex-none" [label]="contact.name.charAt(0)" styleClass="mr-1" size="large" shape="circle"></p-avatar>
          <div class="business-card-name" *ngIf="contact.name">
            <span>{{ contact.name }}</span>
          </div>
          <div class="address flex gap-2 align-items-center text-sm">
            <div class="flex-1">
              <div class="font-normal pt-1">{{ contact.relationships.join(', ') }}</div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="promptedRelationshipStatus?.length">
          <div *ngFor="let promptedRelationship of promptedRelationshipStatus; let index = index; trackBy: trackByRelation" class="flex align-items-center pr-3 mt-3 surface-ground border-round-lg border-1 border-200 text-left">
            <label class="flex-auto cursor-pointer p-3" (click)="$event.preventDefault(); $event.stopPropagation(); onTogglePromptedRelationship(!promptedRelationshipStatus[index], index)">Would you like to add "{{ (relationToDeceased[index] || '').split('-').join(' ') }}" as a relationship?</label>
            <p-inputSwitch class="flex-initial" (onChange)="onTogglePromptedRelationship($event.checked, index)" [(ngModel)]="promptedRelationshipStatus[index]" [ngModelOptions]="{standalone: true}"></p-inputSwitch>
          </div>
        </ng-container>

        <div class="mt-2 pt-2 border-none border-top-1 border-solid border-300 text-xs text-900 flex align-items-center gap-2">
          <p-button styleClass="w-full white-space-nowrap" class="w-3 flex-auto" [label]="contact.phone || 'N/A'" [title]="contact.phone || 'N/A'" [disabled]="!contact.phone" icon="pi pi-phone" (onClick)="onCopyToClipboard($event, contact.phone)"></p-button>
          <p-button styleClass="w-full white-space-nowrap" class="w-3 flex-auto" [label]="contact.email || 'N/A'" [title]="contact.email || 'N/A'" [disabled]="!contact.email" icon="pi pi-envelope" (onClick)="onSend($event, contact.email)"></p-button>
          <p-button styleClass="w-full white-space-nowrap" class="w-3 flex-auto" label="Edit Contact" title="Edit Contact" icon="pi pi-pencil" (onClick)="onEditContact($event)" [badge]="validationErrors?.list?.length ? '!' : '✓'" [badgeClass]="validationErrors?.list?.length ? 'p-badge-warning' : 'p-badge-primary'"></p-button>
        </div>

      </p-card>
    </ng-container>

  </ng-container>

  <ng-template #noContacts>
    <p-card class="card-info w-full">
      <p class="text-center"><strong>No Contacts Created:</strong> Use the button below to add your first contact.</p>
      <p class="text-center mt-3"><button pButton pRipple (click)="onAddNewContact($event)" type="button" label="Add your first contact" icon="pi pi-plus" class="p-button-rounded"></button></p>
    </p-card>
  </ng-template>

  <ng-template #noContact>
    <p-card class="card-info w-full">
      <p class="text-center"><strong>No Contact Selected:</strong> Select an existing contact or use the button below to create a new one.</p>
      <p class="text-center mt-3"><button pButton pRipple (click)="onAddNewContact($event)" type="button" label="Create new contact" icon="pi pi-plus" class="p-button-rounded"></button></p>
    </p-card>
  </ng-template>
</div>
